// src/components/PatientDocumentsTab.js
import React from 'react';
import DocumentsManager from './prescriptions/DocumentsManager';
import ContractsManager from './contracts/ContractsManager';

export default function PatientDocumentsTab({ selectedPatient, openContractId }) {
  if (!selectedPatient || !selectedPatient.id) {
    return (
      <div className="p-4 text-sm text-gray-500">
        Selecione um paciente na lista para visualizar os documentos relacionados a ele.
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Cabeçalho da aba */}
      <div className="bg-white border rounded-lg p-4">
        <h2 className="text-lg font-semibold">Documentos do paciente</h2>
        <p className="text-sm text-gray-600 mt-1">
          Paciente:{' '}
          <span className="font-medium">
            {selectedPatient.full_name || selectedPatient.name || '—'}
          </span>
        </p>
      </div>

      {/* Receituários / atestados / laudos */}
      <div>
        <DocumentsManager patientId={selectedPatient.id} />
      </div>

      {/* Contratos e consentimentos */}
      <div>
        <ContractsManager
          patientId={selectedPatient.id}
          openContractId={openContractId}
        />
      </div>
    </div>
  );
}
